import React from "react";
import { Checkbox, Dropdown } from "semantic-ui-react";

const MultiSelect = (props) => {
  const { disabled, options, selections, compact, onChange } = props;

  return (
    <Dropdown
      disabled={disabled}
      text={
        options.length === selections.length
          ? "All"
          : `${selections.length} Selected`
      }
      compact={compact}
      selection
    >
      <Dropdown.Menu>
        {options
          .filter((x) => x.name !== "All")
          .map((option, index) => {
            const isSelected = selections.includes(option.id);
            return (
              <Dropdown.Item
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onChange(option.id);
                }}
                className="p-0"
              >
                <Checkbox
                  checked={isSelected}
                  disabled
                  className="clickable p-0 m-0"
                  style={{ position: "relative", top: "4px" }}
                />{" "}
                {option.name}
              </Dropdown.Item>
            );
          })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MultiSelect;
